import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Button } from '@material-ui/core';
import Badge from '../Icons/badge';
import { forwardTo } from '../../../utils/helper';
import analytics from '../../../utils/analytics';
import I18n from '../../../config/locales';

const useStyles = makeStyles(theme => ({
  badgeIcon: {
    width: theme.spacing(4.5),
    height: theme.spacing(5.5)
  },
  invitationWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2.5, 3),
    border: '1px solid #FF7141',
    marginBottom: theme.spacing(2.5)
  },
  invitationTextWrapper: {
    padding: theme.spacing(0, 2.5)
  },
  viewButtonWrapper: {
    display: 'flex',
    marginLeft: 'auto',
    textTransform: 'capitalize'
  },
  invitationTextTitle: {
    fontSize: 22,
    letterSpacing: 0.69,
    color: theme.palette.primary.main
  },
  invitationTextLabel: {
    fontSize: 14,
    letterSpacing: 0.42,
    color: '#656565'
  },
  viewButton: {
    color: theme.palette.secondary.main,
    textTransform: 'capitalize'
  }
}));

const EINInvitation = props => {
  const gaAnalytics = new analytics();
  const { hasTier, isUser = false } = props;
  const classes = useStyles();
  const handleClick = () => {
    gaAnalytics.triggerEvent({ event: 'triggerViewDetails' }, {});
    forwardTo('dashboard/ein-program');
  };
  const subText = hasTier ? I18n.t('dashboard.einInvitation') : I18n.t('dashboard.leadsInvitation');
  return (
    <Box className={classes.invitationWrapper}>
      <Badge className={classes.badgeIcon} />
      <Box className={classes.invitationTextWrapper}>
        <Typography className={classes.invitationTextTitle}>{I18n.t('dashboard.congratulations')}</Typography>
        <Typography className={classes.invitationTextLabel}>{subText}</Typography>
      </Box>
      <Box className={classes.viewButtonWrapper}>
        <Button
          className={classes.viewButton}
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleClick()}
          disableElevation
          disabled={isUser}
          id="acceptInvitation"
        >
          {I18n.t('dashboard.acceptInvitation')}
        </Button>
      </Box>
    </Box>
  );
};

export default EINInvitation;
